document.addEventListener('DOMContentLoaded', function () {
    // 要素取得
    const menuOpenBtn = document.querySelector('.menu-bar.-open');
    const menuCloseBtn = document.querySelector('.menu-bar.-close');
    const menuBar = document.querySelector('.menu-bar');
    const slideMenu = document.querySelector('.hdr-slidemenu');
    const bodyInner = document.querySelector('.body-inner');

    // 要素が存在しない場合に備えた防御
    if (!menuOpenBtn || !menuCloseBtn || !menuBar || !slideMenu || !bodyInner) return;

    /**
     * メニューを開く処理
     */
    function openMenu() {
        menuBar.classList.add('select');
        slideMenu.classList.add('select');

        // 現在のスクロール位置を取得
        const scrollPos = window.scrollY || window.pageYOffset || 0;

        // data-scroll 属性に保存（文字列になるため、後で数値化する）
        bodyInner.dataset.scroll = String(scrollPos);

        // スクロールを固定するために top をマイナス値に設定
        bodyInner.classList.add('scroll-prevent');
        bodyInner.style.top = `-${scrollPos}px`;

        // アクセシビリティ対応（任意）
        slideMenu.setAttribute('aria-hidden', 'false');
    }

    /**
     * メニューを閉じる処理
     */
    function closeMenu() {
        menuBar.classList.remove('select');
        slideMenu.classList.remove('select');

        bodyInner.classList.remove('scroll-prevent');
        bodyInner.style.top = '0px';

        // 保存していたスクロール位置を復元
        const savedScroll = Number(bodyInner.dataset.scroll || 0);
        window.scrollTo(0, savedScroll);

        // アクセシビリティ対応（任意）
        slideMenu.setAttribute('aria-hidden', 'true');
    }

    // イベント登録
    menuOpenBtn.addEventListener('click', openMenu);
    menuCloseBtn.addEventListener('click', closeMenu);
});